import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { getImageUrl } from "../../../lib/apiConstants";

const ProductView = ({ product }) => {
  // sticky top-[100px]
  return (
    <Zoom>
      <div className="h-[512px] max-[992px]:h-[350px] max-[450px]:h-[290px] max-sm:h-[400px] max-sm:w-full max-[992px]:w-[300px] max-[820px]:h-[290px] max-[820px]:w-[227px] w-[481px] py-7 px-[58px] max-[992px]:px-1 max-[992px]:py-2 border rounded-lg flex justify-center items-center border-[#EEEEEF] cursor-pointer hover:border-[#4B68C6] transition-all ease-in-out">
        {product?.image?.url && (
          <img
            src={getImageUrl(product?.image?.url)}
            alt={product?.image?.alt || "Product Image"}
            className="w-full h-full object-contain"
          />
        )}
      </div>
    </Zoom>
  );
};

export default ProductView;
